'use client'

import { useMasterData } from 'master-data/hooks/useMasterData/useMasterData'
import { ProductCard } from 'product-card/components/ProductCard'
import { ProductCardProvider } from 'product-card/context/ProductCardContext'
import { useProductDataContext } from 'product-card/hooks/useProductDataContext'
import { type ProductCardProps } from 'product-card/types'
import { useProductInfo } from 'product/services/productInfo/client'

import styles from './ClientProductCard.module.scss'

export const ClientProductCard = ({
	productId,
	lookId,
	colorId,
	imageSortCriteria,
	priority,
	dataTestId,
	isTwoColumnSize,
	className,
	location,
	hasProductLabels = true,
	hasProductTags = true,
	hasColorPicker = true,
	hasSizeSheetButton = false,
	hasFavoriteButton = true,
}: ProductCardProps) => {
	const {
		country: { countryISO, languageISO },
	} = useMasterData()

	const { productData: productDataFromServer } = useProductDataContext()
	const isProductDataFromServer = !!productDataFromServer

	const { data: productDataFromClient, isLoading: isProductLoading } =
		useProductInfo({
			productId,
			country: countryISO,
			language: languageISO,
			enabled: !isProductDataFromServer,
		})

	const productData = productDataFromServer ?? productDataFromClient

	const isProductCardLoading = isProductLoading || !productData

	if (isProductCardLoading) {
		return <div className={styles.productCardSpinner} />
	}

	return (
		<ProductCardProvider
			initialProductId={productId}
			initialDataTestId={dataTestId}
			initialLookId={lookId}
			initialColorId={colorId}
			location={location}
			initialHasProductLabels={hasProductLabels}
			initialHasProductTags={hasProductTags}
			initialHasColorPicker={hasColorPicker}
			initialHasSizeSheetButton={hasSizeSheetButton}
			initialHasFavoriteButton={hasFavoriteButton}
		>
			<ProductCard
				className={className}
				product={productData}
				isLoading={isProductLoading}
				imageSortCriteria={imageSortCriteria}
				priority={priority}
				isTwoColumnSize={isTwoColumnSize}
			/>
		</ProductCardProvider>
	)
}
